<script>
import { AppLayout, PageHeader } from '@/components/layout'
import appConfig from '@/app.config'
import tableMixin from '@/mixins/table'
import api from '@/helpers/api'
import { required, minValue, decimal } from 'vuelidate/lib/validators'
import _ from 'lodash'
import isEmpty from 'lodash/isEmpty'
import groupBy from 'lodash/groupBy'
import mapValues from 'lodash/mapValues'
import omit from 'lodash/omit'
import Forms from '@/components/forms'
import { mapGetters } from 'vuex'
import { authComputed } from '@/state/helpers'

export default {
  name: 'sales.forms.list',
  mixins: [tableMixin],
  page: {
    title: 'Cart',
    meta: [{ name: 'description', content: appConfig.description }]
  },
  props: {
    title: { type: String, default: 'My Cart' }
  },
  components: {
    AppLayout,
    PageHeader
  },
  data () {
    return {
      isLoading: false,
      search: null,
      showCustomForm: false,
      previewStlFileId: null,
      previewStl: false,
      previewStlUrl: '',
      fileLoadProgress: 0,
      selectedItem: { item: {} },
      lights: [
        {
          type: 'point',
          color: '#0095f5',
          intensity: 1
        }
      ],
      fields: [
        {
          key: 'item',
          label: 'Item'
        },
        {
          key: 'reference',
          label: 'Reference'
        },
        {
          key: 'shipping',
          label: 'Shipping'
        },
        {
          key: 'quantity',
          label: 'Qty.',
          class: 'text-center',
          thStyle: { width: '80px' }
        },
        {
          key: 'actions',
          label: '',
          thStyle: { width: '120px' },
          class: 'text-right align-middle'
        }
      ]
    }
  },
  mounted () {
    this.onRefresh()
  },
  watch: {
    search: 'onRefresh',
    currentPage: 'onRefresh',
    perPage: 'onRefresh',
    cartCount: 'onRefresh'
  },
  methods: {
    isEmpty,
    onStlLoadProcess (event, index) {
      this.fileLoadProgress = Math.floor((event.loaded / event.total) * 100)

      if (this.fileLoadProgress < 100) this.isFileLoading = true
      else this.isFileLoading = false
    },
    async onPreviewStlFile (file_id) {
      if (this.previewStl && this.previewStlFileId === file_id)
        this.previewStl = false
      else {
        this.previewStl = true

        let { url } = await api.files.download_url({
          file_id
        })
        this.previewStlUrl = url
        this.previewStlFileId = file_id
      }
    },
    async onRefresh () {
      this.isLoading = true
      let { items, total_rows } = await api.webForms.fetchPage({
        page: this.currentPage,
        pageSize: -1,
        needle: this.search,
        orderBy: [{ created_at: 'asc' }],
        filters: [{ is_submitted: { _eq: false } }]
      })
      this.data = items
      this.totalRows = total_rows
      this.isLoading = false
    },
    async onClearCart () {
      let ok = await this.$bvModal.msgBoxConfirm(
        'Please confirm that you want to clear the cart.',
        {
          title: 'Please Confirm',
          size: 'md',
          okVariant: 'primary',
          cancelVariant: 'link',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )

      if (ok) {
        await this.$store.dispatch('cart/clearCart')
        this.onRefresh()
      }
    },
    async onCheckoutCart () {
      let ok = await this.$bvModal.msgBoxConfirm(
        'Please confirm that you want to Checkout the cart.',
        {
          title: 'Confirm Cart Checkout',
          size: 'md',
          okVariant: 'primary',
          cancelVariant: 'link',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )

      if (ok) {
        await this.$store.dispatch('cart/checkoutCart')
        this.onRefresh()
      }
    },

    async onCheckoutItem (item) {
      let ok = await this.$bvModal.msgBoxConfirm(
        'Please confirm that you want to checkout this item.',
        {
          title: 'Confirm Item Checkout',
          size: 'md',
          okVariant: 'primary',
          cancelVariant: 'link',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )

      if (ok) {
        await this.$store.dispatch('cart/checkoutItem', { item })
        this.onRefresh()
      }
    },
    onEditHandler (item) {
      const {
        reference,
        file_id,
        item_id,
        form_data = {},
        comments,
        shipping_address_id
      } = item
      this.selectedItem = {
        ...item,
        specifications: {
          images: item.web_form_files,
          reference,
          file_id,
          item_id,
          comments,
          enable_shipping: shipping_address_id ? 'yes' : 'no',
          shipping_address_id,
          specs: form_data
        }
      }
      this.showCustomForm = true
    },
    async onRemoveHandler (item) {
      let ok = await this.$bvModal.msgBoxConfirm(
        'Please confirm that you want to delete this Item.',
        {
          title: 'Please Confirm',
          size: 'md',
          okVariant: 'primary',
          cancelVariant: 'link',
          okTitle: 'Yes',
          cancelTitle: 'No',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        }
      )

      if (ok) {
        await this.$store.dispatch('cart/removeFromCart', {
          id: item.id,
          file_id: item.file_id
        })
        this.onRefresh()
      }
    },
    async onQuantityUpdated (item) {
      if (!this.$v.$invalid) {
        await this.$store.dispatch('cart/updateCartItem', {
          data: { ...item },
          id: item.id
        })
        this.$bvToast.toast(
          `Quantity for ${item.item.short_description} (ref. ${item.reference}) was updated!`,
          {
            title: 'Quantity updated',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 1000,
            appendToast: true
          }
        )
      } else {
        this.$bvToast.toast(`Quantity must must be greater than zero!`, {
          title: 'Error',
          solid: true,
          toaster: 'b-toaster-top-center',
          variant: 'danger',
          autoHideDelay: 1000,
          appendToast: true
        })
        item.quantity = 1
      }
    },
    async onCustomFormComplete (item) {
      const {
        reference,
        file_id,
        enable_shipping,
        shipping_address_id,
        comments,
        images,
        specs = {}
      } = item

      const { id } = this.selectedItem

      await this.$store.dispatch('cart/updateCartItem', {
        data: {
          reference,
          file_id,
          shipping_address_id: enable_shipping ? shipping_address_id : null,
          comments,
          form_data: specs
        },
        web_form_files: images,
        id
      })
      this.$bvToast.toast(
        `${this.selectedItem.item.short_description} was updated!`,
        {
          title: 'Quantity updated',
          solid: true,
          toaster: 'b-toaster-top-center',
          variant: 'success',
          autoHideDelay: 1000,
          appendToast: true
        }
      )
      this.onRefresh()
      this.selectedItem = { item: {} }
      this.showCustomForm = false
    },
    onStlError (error) {
      console.error(error)
    }
  },
  computed: {
    ...authComputed,
    ...mapGetters('cart', ['cartCount']),
    customForm () {
      const { webshop_custom_form } = this.selectedItem.item
      if (
        Forms.hasOwnProperty(webshop_custom_form) &&
        Forms[webshop_custom_form].component
      )
        return Forms[webshop_custom_form].component
      return null
    },
    breadcrumbs () {
      return [
        {
          text: 'Cart',
          active: false
        },
        {
          text: 'My Forms',
          active: true
        }
      ]
    }
    /* groupedData () {
      return _(this.data)
        .groupBy(x => !!x.product.custom_form)
        .map((items, has_custom_form) => ({
          has_custom_form: has_custom_form === 'true',
          items
        }))
        .value()
    } */
  },
  validations () {
    return {
      data: {
        $each: {
          quantity: {
            required,
            decimal,
            minValue: minValue(1)
          }
        }
      }
    }
  }
}
</script>

<template>
  <AppLayout>
    <PageHeader :title="$t(title)" :items="breadcrumbs" />
    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row mb-2">
              <div class="col-sm-4">
                <g-search-input v-model="search" width="300px" />
              </div>
              <div class="col-sm-8">
                <div class="text-sm-right">
                  <div class="d-flex justify-content-end pb-2">
                    <b-btn variant="link" v-on:click="onRefresh" class="mx-0"
                      ><i class="fas fa-sync"></i
                    ></b-btn>

                    <b-btn
                      variant="link"
                      class="mx-2"
                      :disabled="data.length === 0"
                      v-on:click="onClearCart"
                      >Clear Cart</b-btn
                    >
                    <b-btn
                      variant="primary"
                      class="btn-label"
                      :disabled="data.length === 0"
                      v-on:click="onCheckoutCart"
                      ><i class="bx bx-mail-send label-icon"></i>Checkout</b-btn
                    >
                  </div>
                </div>
              </div>
              <!-- end col-->
            </div>

            <!-- Table data -->

            <b-table
              show-empty
              :items="data"
              :fields="fields"
              :busy="isLoading"
              head-variant="primary"
              borderless
              thead-tr-class="bg-light"
              tbody-tr-class="border-bottom mb-0"
              small
            >
              <template v-slot:empty>
                <div class="text-center p-3">No Items in your cart!</div>
              </template>

              <template v-slot:cell(item)="{ item }">
                <div class="d-flex justify-content-start align-items-center">
                  <span class="text-truncate">{{
                    item.item.short_description
                  }}</span>

                  <template v-if="item.form_data.is_remill">
                    <i
                      :id="`ttRemill${item.id}`"
                      class="mdi mdi-alpha-r-box text-primary font-size-16 ml-2"
                    ></i>
                    <b-tooltip
                      :target="`ttRemill${item.id}`"
                      variant="dark"
                      placement="right"
                    >
                      {{ $t('Remill') }}
                    </b-tooltip>
                  </template>
                  <template v-if="!!item.file">
                    <i
                      :id="`ttFile${item.file_id}${item.id}`"
                      class="mdi mdi-file-check-outline text-primary font-size-16 ml-2"
                    ></i>
                    <b-tooltip
                      :target="`ttFile${item.file_id}${item.id}`"
                      variant="dark"
                      title="File"
                      placement="right"
                    >
                      <strong>
                        {{ item.file.file_name }}
                      </strong>
                      <small class="mx-2">{{
                        item.file.file_size | prettyBytes
                      }}</small>
                    </b-tooltip>
                    <b-btn
                      v-if="userRole === 'admin'"
                      variant="link"
                      class="m-0 px-0"
                      v-on:click="onPreviewStlFile(item.file_id)"
                    >
                      <i
                        :id="`checkFile${item.file_id}${item.id}`"
                        class="mdi mdi-file-eye text-primary font-size-16 ml-2"
                      ></i>
                    </b-btn>
                  </template>
                </div>

                <small v-if="item.form_data.hasOwnProperty('model_type')">
                  {{ $t(`attribute.model_type.${item.form_data.model_type}`) }}
                </small>
              </template>

              <template v-slot:cell(reference)="{ item }">
                <span v-if="!!item.reference">{{ item.reference }}</span>
                <span v-else>{{ $t(`no reference`) }}</span>
                <br />
                <span
                  class="small m-0"
                  v-if="item.form_data.hasOwnProperty('foam_type')"
                  :id="`ttFoamType${item.id}`"
                >
                  {{ $t(`attribute.foam_type.${item.form_data.foam_type}`) }}
                </span>
                <b-tooltip
                  v-if="
                    item.form_data.hasOwnProperty('foam_type') &&
                    item.form_data.foam_type === 'mix'
                  "
                  :target="`ttFoamType${item.id}`"
                  variant="dark"
                  placement="right"
                  custom-class="text-left"
                  style="min-width: 300px"
                >
                  <p class="mx-2 my-0">
                    {{ $t('Seat') }}:
                    {{
                      $t(
                        `attribute.foam_type.${item.form_data.mix_seat_foam_type}`
                      )
                    }}<br />
                    {{ $t('Back') }}:
                    {{
                      $t(
                        `attribute.foam_type.${item.form_data.mix_back_foam_type}`
                      )
                    }}
                  </p>
                </b-tooltip>
              </template>
              <template v-slot:cell(shipping)="{ item }">
                <p class="m-0 text-muted" v-if="item.shipping_address">
                  <i class="mdi mdi-cube-send text-muted mr-1 font-size-18"></i>
                  {{ item.shipping_address.company_name }},
                  {{ item.shipping_address.city }} ({{
                    item.shipping_address.country_code
                  }})
                </p>
                <p v-else class="m-0 text-muted">{{ $t(`no shipping`) }}</p>
              </template>

              <template v-slot:cell(specs)="{ item }">
                <template v-if="!isEmpty(item.form_data)">
                  <i
                    class="far fa-list-alt pointer"
                    :id="`tt-specs-${item.id}`"
                  />
                  <b-popover
                    :target="`tt-specs-${item.id}`"
                    triggers="hover"
                    placement="bottomleft"
                    class="d-flex flex-column"
                    :title="$t('Specifications')"
                    variant="dark"
                  >
                    <template v-if="item.file_id">
                      <span class="d-block mb-2">
                        {{ item.file.file_name }}
                        <small>
                          ({{ item.file.file_size | prettyBytes }})
                        </small>
                      </span>
                    </template>
                    <template v-for="spec in Object.keys(item.form_data)">
                      <div
                        :key="`${spec}_${item.id}`"
                        v-if="item.form_data[spec]"
                      >
                        {{ $t(`attribute.${spec}.key`) }}:
                        {{
                          $t(`attribute.${spec}.value`, {
                            value: $te(
                              `attribute.${spec}.${item.form_data[spec]}`
                            )
                              ? $t(`attribute.${spec}.${item.form_data[spec]}`)
                              : $t(`${item.form_data[spec]}`)
                          })
                        }}
                      </div>
                    </template>
                  </b-popover>
                </template>
              </template>

              <template v-slot:cell(quantity)="{ item }">
                <div class="d-flex justify-content-center">
                  <b-form-input
                    v-model.number="item.quantity"
                    class="text-center m-0"
                    v-on:focus="$event.target.select()"
                    v-on:change="onQuantityUpdated(item)"
                    size="sm"
                    style="max-width: 50px"
                  />
                </div>
              </template>

              <template v-slot:cell(actions)="{ item }">
                <b-btn
                  variant="link"
                  class="p-1 mx-1"
                  v-on:click="onEditHandler(item)"
                  v-if="item.item.webshop_custom_form"
                  ><i class="bx bx-edit text-primary font-size-16"></i
                ></b-btn>
                <b-btn
                  variant="link"
                  class="p-1 mx-1 text-center"
                  v-on:click="onRemoveHandler(item)"
                  ><i class="bx bx-trash text-danger font-size-16"></i
                ></b-btn>
                <b-btn
                  variant="link"
                  class="p-1 mx-1"
                  v-on:click="onCheckoutItem(item)"
                  ><i class="bx bx-mail-send text-primary font-size-16"></i
                ></b-btn>
              </template>
            </b-table>
          </div>

          <!-- end card-body -->
        </div>

        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->

    <b-modal
      v-model="previewStl"
      centered
      size="lg"
      hide-footer
      hide-header
      static
      body-class="p-2"
    >
      <h6
        class="px-3 py-2 pb-3mb-1 font-weight-light border-bottom border-light"
      >
        Preview STL
      </h6>
      <vue3dLoader
        :key="previewStlFileId"
        :filePath="previewStlUrl"
        fileType="stl"
        :enableAxesHelper="true"
        :axesHelperSize="500"
        :enableDamping="true"
        :dampingFactor="0.05"
        :height="450"
        :lights="lights"
        :controlsOptions="{
          enablePan: false,
          enableZoom: false
        }"
        :pointLightFollowCamera="true"
        backgroundColor="#FFFFFF"
        @process="onStlLoadProcess"
        @error="onStlError"
        class="p-0 m-0"
      />
      <b-progress
        v-show="fileLoadProgress < 100"
        :value="fileLoadProgress"
        height="2px"
      ></b-progress>
    </b-modal>

    <b-modal
      v-model="showCustomForm"
      centered
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      size="lg"
      hide-footer
      hide-header
      body-class="p-2"
    >
      <h6
        class="px-3 py-2 pb-3mb-1 font-weight-light border-bottom border-light"
      >
        {{ selectedItem.item.short_description }}
      </h6>
      <component
        :is="customForm"
        :submit-label="$t('save changes')"
        submit-icon="bx bx-save"
        v-model="selectedItem.specifications"
        v-on:complete="onCustomFormComplete"
        v-on:cancel="showCustomForm = false"
        v-if="showCustomForm"
      />
    </b-modal>
  </AppLayout>
</template>

<style lang="scss">
.table-sm td {
  padding: 0.5rem 0.5rem;
  vertical-align: middle;
}
</style>
